import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { RootState } from '../store/configureStore';
import { EmailForgotPassword, EmailMessage, EmailNotifyStock } from '../types/Email';
import { forgotPassword, notifyStock, submitMessage } from '../api/EmailApi';

export const emailSubmitMessage = (data: EmailMessage):
ThunkAction<void, RootState, unknown, Action<string>> =>
  async () => {
    await submitMessage(data);
  };

export const emailForgotPassword = (data: EmailForgotPassword):
ThunkAction<void, RootState, unknown, Action<string>> =>
  async () => {
    await forgotPassword(data);
  };

export const emailNotifyStock = (data: EmailNotifyStock):
ThunkAction<void, RootState, unknown, Action<string>> =>
  async () => {
    await notifyStock(data);
  };
